<script>
export default {
    name: "TrialBalance",

    data() {

        return {
            filter: {
                userName: this.$root.username,
                trialBalanceDetails: [
                    {
                        fromDate: this.$moment().format(`YYYY-MM-DD`),
                        toDate: this.$moment().format(`YYYY-MM-DD`)
                    },
                ]
            },
            defaultFilter: 1,
            trialBalance: {
                trialBalance: [],
                coaDetails: [],
            },
            fps: [],
        };
    },

    computed: {

        groups() {
            if(!this.trialBalance.trialBalance.length) return [];

            let groups = this.trialBalance.trialBalance.map(tB => tB.groupId);

            let groupsSet = new Set(groups);

            return Array.from(groupsSet);
        },
    },

    watch: {

        defaultFilter() {

            switch (this.defaultFilter) {
                    case 1: 
                        this.filter.trialBalanceDetails = [{
                                fromDate: this.$moment().format(`YYYY-MM-DD`),
                                toDate: this.$moment().format(`YYYY-MM-DD`)
                            }];
                        break;
                    case 2:
                        this.filter.trialBalanceDetails = [{
                                fromDate: this.$moment().format(`YYYY-MM-DD`),
                                toDate: this.$moment().format(`YYYY-MM-DD`)
                            }];
                        this.filter.trialBalanceDetails.push({
                            fromDate: null,
                            toDate: null
                        });
                        break;
                    case 3:
                        this.filter.trialBalanceDetails = [{
                                fromDate: this.$moment().format(`YYYY-MM-DD`),
                                toDate: this.$moment().format(`YYYY-MM-DD`)
                            }];
                        this.filter.trialBalanceDetails.push(...[
                            {
                                fromDate: null,
                                toDate: null
                            },
                            {
                                fromDate: null,
                                toDate: null
                            },
                        ]);
                        break;
                    case 4:
                        this.filter.trialBalanceDetails = [{
                                fromDate: this.$moment().format(`YYYY-MM-DD`),
                                toDate: this.$moment().format(`YYYY-MM-DD`)
                            }];
                        this.filter.trialBalanceDetails.push(...[
                            {
                                fromDate: null,
                                toDate: null
                            },
                            {
                                fromDate: null,
                                toDate: null
                            },
                            {
                                fromDate: null,
                                toDate: null
                            }
                        ]);
                        break;
                    default:
                        break;
                }
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchFinancialPeriods(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchTrialBalance() {
            let url = `Accounting/TrialBalance`;

            return this.$http.post(url, this.filter).then(({ data }) => {
                this.trialBalance = data;
            }).catch(() => {});
        },

        fetchFinancialPeriods() {

            return this.$http.get(`Accounts/GetFinancialPeriods`).then(({ data }) => {
                this.fps = data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap items-center">
    <div class="w-full flex flex-wrap items-center">
        <div class="md:w-1/6 w-full p-tiny">
            <label for="grid-depth" class="label-control">Depth</label>
            <tail-select>
                <template v-slot:field>
                    <select id="grid-depth" v-model="defaultFilter" class="input-control input-sm text-xs">
                        <option :value="1">Default</option>
                        <option :value="2">Two</option>
                        <option :value="3">Three</option>
                        <option :value="4">Four</option>
                    </select>
                </template>
            </tail-select>
        </div>
        <div class="md:w-4/6 w-full p-tiny flex flex-row">
            <div 
                v-for="(dateFilter, idx) in filter.trialBalanceDetails" :key="idx"
                class="w-1/5 flex flex-col">
                <div class="w-full p-tiny">
                    <label class="label-control">Period</label>
                    <tail-select>
                        <template v-slot:field>
                            <select id="" class="input-control input-sm text-xs">
                                <option :value="0">select period</option>
                                <option v-for="fp in fps" 
                                    :key="fp.periodId" :value="fp.periodId">{{ fp.periodYr }}</option>
                            </select>
                        </template>
                    </tail-select>
                </div>
                <div class="w-full p-1">
                    <label for="grid-date-from" class="label-control">From:</label>
                    <input type="date" v-model.trim="dateFilter.fromDate" 
                        id="grid-date-from" class="input-control input-sm text-xs">
                </div>
                <div class="w-full p-1">
                    <label for="grid-date-to" class="label-control">To:</label>
                    <input type="date" v-model.trim="dateFilter.toDate" 
                        id="grid-date-to" class="input-control input-sm text-xs">
                </div>
            </div>
        </div>
        <div class="md:w-1/6 w-full p-1">
            <button 
                @click.prevent="() => {
                    $root.loading = true;
                    fetchTrialBalance().then(() => {
                        $root.loading = false;
                    });
                }"
                class="btn-sm btn-primary text-xs rounded mt-4">Filter</button>
        </div>
    </div>
    <div class="w-full overflow-auto" style="max-height:35rem;">
        <table class="table text-xs">
            <thead class="bg-blue-500 text-white">
                <tr class="w-full flex">
                    <th class="p-tiny w-1/5 break-words">COA</th>
                    <th class="p-tiny flex-1 flex" v-for="grp in groups" :key="grp">
                        <div class="flex-1">
                            Debit
                        </div>
                        <div class="flex-1">
                            Credit
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody class="bg-gray-100">
                <tr class="w-full flex" v-for="(tB, idx) in trialBalance.trialBalance" :key="idx">
                    <td class="p-tiny w-1/5 break-words">{{ tB.coaName }}</td>
                    <td class="p-tiny flex-1 flex" v-for="grp in groups" :key="grp">
                        <div class="flex-1">
                            {{ trialBalance.trialBalance.filter(tb => tb.groupId == grp && tB.coaid == tb.coaid).length ?
                                $formatCurrency(trialBalance.trialBalance.filter(tb => tb.groupId == grp && tB.coaid == tb.coaid)[0].debitAmount) :
                                `-`
                             }}
                        </div>
                        <div class="flex-1">
                            {{ trialBalance.trialBalance.filter(tb => tb.groupId == grp && tB.coaid == tb.coaid).length ?
                                $formatCurrency(trialBalance.trialBalance.filter(tb => tb.groupId == grp && tB.coaid == tb.coaid)[0].creditAmount) :
                                `-`
                             }}
                        </div>
                    </td>
                </tr>
            </tbody>
            <tfoot class="bg-gray-200 text-sm">
                <tr class="w-full flex">
                    <th class="p-tiny w-1/5">Total:</th>
                    <th class="p-tiny flex-1 flex"  v-for="grp in groups" :key="grp">
                        <div class="flex-1">
                            {{ 
                                trialBalance.trialBalance.filter(tb => tb.groupId == grp).length ?
                                $formatCurrency(trialBalance.trialBalance.filter(tb => tb.groupId == grp)
                                    .map(tb => parseFloat(tb.debitAmount))
                                    .reduce((sum, debit) => sum+debit)) :
                                `-`
                             }}
                        </div>
                        <div class="flex-1">
                            {{ 
                                trialBalance.trialBalance.filter(tb => tb.groupId == grp).length ?
                                $formatCurrency(trialBalance.trialBalance.filter(tb => tb.groupId == grp)
                                    .map(tb => parseFloat(tb.creditAmount))
                                    .reduce((sum, credit) => sum+credit)) :
                                `-`
                             }}
                        </div>
                    </th>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
</template>
